/* Dough Dorks: remove legacy DORKTOBER gift-line items only. No checkout, discounts, or shipping rules are changed. */
(function () {
  'use strict';
  if (window.__DD_RETIRED_DORKTOBER_GIFTS__) return;
  window.__DD_RETIRED_DORKTOBER_GIFTS__ = true;
  function wasLegacyGift(item) {
    var props = item && item.properties;
    return !!(props && (Object.prototype.hasOwnProperty.call(props, '_Dorktober gift') ||
      String(props.DORKTOBER || '').toUpperCase() === 'FREE GIFT'));
  }
  async function removeLegacyGifts() {
    try {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var response = await fetch(root + 'cart.js', {credentials: 'same-origin', cache: 'no-store'});
      if (!response.ok) return;
      var cart = await response.json();
      var gifts = (cart.items || []).filter(wasLegacyGift);
      if (!gifts.length) return;
      for (var i = 0; i < gifts.length; i++) {
        if (!gifts[i].key) continue;
        var changed = await fetch(root + 'cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({id: gifts[i].key, quantity: 0})
        });
        if (!changed.ok) throw new Error('Legacy gift cart cleanup failed: ' + changed.status);
      }
      window.location.reload();
    } catch (err) {
      console.warn('[Dough Dorks] Old gift cleanup could not finish', err);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeLegacyGifts, {once: true});
  } else {
    removeLegacyGifts();
  }
})();
